import { useUserRoleStore } from "../../stores/userRoleStore";
import { permissionsMap } from "../constants";
import { GranularScope, HookResult, Scope } from "./types";

const useRolePermission = (scope: Scope | GranularScope): HookResult => {
  const { roles, loading } = useUserRoleStore();

  if (loading) {
    return {
      loading,
      allowed: null,
    };
  }

  if (!roles.length) {
    return {
      loading: false,
      allowed: false,
    };
  }

  return {
    loading: false,
    allowed:
      permissionsMap[scope]?.some((allowedRole) =>
        roles.includes(allowedRole),
      ) ?? false,
  };
};

export default useRolePermission;
